import React, { useContext, useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import { CiSearch } from "react-icons/ci";
import DispatchOrderCard from "./DispatchOrderCard";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import OrderApi from "../../../../App/api/order.apis";
import LoaderContext from "../../../../Components/loader";

const item = [];
function DispatchNavCard({ setDeliveryStatus,sx, tabs, setTab, allDeliveryMan,fetchAllDeliveryMan }) {
  const [search, setSearch] = useState("");
  const [activeType, setActiveType] = useState("ecommerce");
  const [value, setValue] = useState("");
  const [clickedTab, setClickedTab] = useState({
    tab: "New"
  });
  const { handleLoading } = useContext(LoaderContext);
  const [pagination, setPagination] = useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {
      "orderDetails.delivery_status": "ASSIGNED"
    },
  });
  const [foodPagination, setFoodPagination] = useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {
      "delivery_status": "ASSIGNED"
    },
  });
  useEffect(() => {
    if (clickedTab.tab === "Assigned") {
      setDeliveryStatus()
      setPagination({
        page: 1,
        limit: 5,
        sortOrder: "desc",
        filter: {
          "orderDetails.delivery_status": "ASSIGNED_TO_DELIVERYMAN",
        },
      });
      setFoodPagination({
        page: 1,
        limit: 5,
        sortOrder: "desc",
        filter: {
          "delivery_status": "ASSIGNED_TO_DELIVERYMAN",
        },
      });
    } else if (clickedTab.tab === "New") {
      setDeliveryStatus({
            filter: {
              "availability.status": "available"
            },
            "page": 1,
            "limit": 10,
            "sortOrder": "desc"
      })
      setPagination({
        page: 1,
        limit: 5,
        sortOrder: "desc",
        filter: {
          "orderDetails.delivery_status": "ASSIGNED",
        },
      });
      setFoodPagination({
        page: 1,
        limit: 5,
        sortOrder: "desc",
        filter: {
          "delivery_status": "ASSIGNED",
        },
      });
    }
  }, [clickedTab]);
  
  // const { value, fetchAllData } = useFetchAll(() =>
  //   OrderApi.getAllOrders(pagination ? pagination : {}, search)
  // );
  const OrderDataFun = async () => {
    handleLoading(true);
    try {
      const res = activeType === 'ecommerce'
        ? await OrderApi.getAllOrders(pagination ? pagination : {}, search)
        : await OrderApi.getAllFoodOrders(foodPagination ? foodPagination : {}, search);
  
      console.log("Operation successful:",res.data.data);
      console.log("activeType:",activeType);
      setValue(res.data);
      return res; // Optional: Return the result if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
    finally{handleLoading(false);}
  };

  const handleClick = (t, i) => {
    console.log("tab",t);
    setClickedTab(t);
    // console.log("Index",i);
    const updatedTabs = tabs.map((item, index) => {
      if (index === i) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    // console.log("tabs",updatedTabs);
    setTab(updatedTabs);
  };
useEffect(() => {
  OrderDataFun();
}, [pagination, foodPagination, activeType]);
  
  console.log("order dispatch:", value?.data?.orders);

  return (
    <>
     <div style={sx ? sx : {}} className={[`${Styles.navContainer}`]}>
    
     <div className=" p-6 flex justify-between gap-4 w-full border">
        <p onClick={()=>setActiveType('ecommerce')} 
        className={`text-lg cursor-pointer p-3 ${
          activeType === 'ecommerce' ? 'border-t-2 border-red-500 text-red-500' : ''
        }`}>Ecommerce</p>

        <p onClick={()=>setActiveType('restaurant')} 
        className={`text-lg cursor-pointer p-3 ${
          activeType === 'restaurant' ? 'border-t-2 border-red-500 text-red-500' : ''
        }`}>Restaurant</p>
      </div>

      <div className={[`${Styles.nav}`]}>
        {tabs.map((t, i) => (
          <button
            key={i}
            onClick={() => handleClick(t, i)}
            className={
              t.isActive
                ? [`${Styles.active} ${Styles.navItem}`]
                : [`${Styles.navItem}`]
            }
          >
            {t.tab}
          </button>
        ))}
      </div>
      <div style={{ paddingInline: "2rem" }}>
  
  {/* Search + Limit */}
  <div className="flex justify-between items-center gap-3 mb-3">
    <div className={`${Styles.border_search} flex items-center px-2 w-full`}>
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search"
        className="bg-transparent outline-none w-full"
      />
      <CiSearch size={"1.1rem"} />
    </div>

    <select
      value={pagination.limit}
      onChange={(e) => {
        const newLimit =
          e.target.value === "all" ? 1000 : Number(e.target.value);

        setPagination((prev) => ({
          ...prev,
          page: 1,
          limit: newLimit,
        }));

        setFoodPagination((prev) => ({
          ...prev,
          page: 1,
          limit: newLimit,
        }));
      }}
      className="border rounded-md px-2 py-1 text-sm"
    >
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={15}>15</option>
      <option value={20}>20</option>
      <option value="all">All</option>
    </select>
  </div>

  {/* ✅ SCROLLABLE LIST */}
  <div className="h-[60vh] overflow-y-auto pr-2">
    
    {clickedTab.tab === "New" &&
      value?.data?.orders.map((item) => (
        <DispatchOrderCard
          key={item.id}
          item={item}
          OrderDataFun={OrderDataFun}
          activeType={activeType}
          allDeliveryMan={allDeliveryMan}
          fetchAllDeliveryMan={fetchAllDeliveryMan}
        />
      ))}

    {clickedTab.tab === "Assigned" &&
      value?.data?.orders.map((item) => (
        <DispatchOrderCard
          key={item.id}
          item={item}
          OrderDataFun={OrderDataFun}
          activeType={activeType}
          selectedSubTab={clickedTab.tab}
          allDeliveryMan={allDeliveryMan}
          fetchAllDeliveryMan={fetchAllDeliveryMan}
        />
      ))}

  </div>
</div>
    </div>
    </>
   
  );
}

export default DispatchNavCard;
